import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { getUnitList } from "./unit.api";
import { UnitModel, UnitState } from "./unit.models";

export const fetchUnitList = createAsyncThunk(
  "unit/fetchUnitList",
  async (any, thunkApi) => {
    try {
      const res = await getUnitList();
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const unitSlice = createSlice({
  name: "unit",
  initialState: {
    units: [] as UnitModel[],
  } as UnitState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUnitList.fulfilled, (state, action) => {
      state.units = action.payload;
    });
  },
});

export const unitListSelector =  (state: RootState) => state.unit.units;
